import { useReportsApi } from '@/hooks'
import { EditableTitle } from '@molecules'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type ReportEditableTitleContainerProps = {
    initialValue: string
    value: string
    onChange?: (val: string) => void
}

export const ReportEditableTitleContainer: React.FC<
    ReportEditableTitleContainerProps
> = (props) => {
    const { initialValue, value, onChange } = props
    const [isEditing, setIsEditing] = useState(false)
    const [isQueryEnabled, setIsQueryEnabled] = useState(false)
    const { useReportNameExists } = useReportsApi()
    const { t } = useTranslation('translations')
    const { data, isSuccess, isLoading } = useReportNameExists(value, {
        onSuccess: () => {
            setIsQueryEnabled(false)
        },
        onError: () => {
            setIsQueryEnabled(false)
        },
        enabled: isQueryEnabled && initialValue !== value,
    })

    const reportNameExists = initialValue !== value && isSuccess && data

    return (
        <EditableTitle
            onEdit={() => {
                setIsEditing(true)
            }}
            onConfirm={() => {
                setIsQueryEnabled(true)
                setIsEditing(false)
            }}
            value={value}
            isEditing={isEditing}
            isLoading={isLoading}
            errorText={
                reportNameExists
                    ? t(
                          'reporting.update_report.duplicate_report_name_error_description'
                      )
                    : undefined
            }
            onChange={onChange}
        />
    )
}
